// extracted by mini-css-extract-plugin
export var statItem = "_kk-1";
export var statsRow = "_kk-0";